// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-8a00df62]{display:flex;height:100%;width:100%;overflow-y:auto;border-radius:.5rem;--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity))}.mobile-card-text[data-v-8a00df62]{padding:.625rem;border-top-right-radius:.5rem;border-bottom-right-radius:.5rem}img[data-v-8a00df62]{border-top-left-radius:.5rem;border-bottom-left-radius:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
